import { render, staticRenderFns } from "./smartwriting.vue?vue&type=template&id=46b7e99e&scoped=true&lang=pug"
import script from "./smartwriting.vue?vue&type=script&lang=ts"
export * from "./smartwriting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7e99e",
  null
  
)

export default component.exports